import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import OrderListRow from "./OrderListRow";
import axiosConfig from "../../../services/Axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

function OrderList({ orders, setOrders, loadOrders = null }) {
  const authUser = useSelector((state) => state.auth);
  const isAdmin = authUser?.user?.roles.includes("ROLE_ADMIN");
  const { t } = useTranslation();

  const updateState = async (order, state) => {
    Swal.fire({
      text: t("settings.orders.changeStateQuestion", {
        previous_state: t("settings.orders.state." + order.state),
        state: t("settings.orders.state." + state),
      }),
      icon: "question",
      showCancelButton: true,
      confirmButtonText: t("global.btn.confirm_modify"),
      cancelButtonText: t("global.btn.cancel"),
      customClass: {
        actions: "gap-2 h-20",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          axiosConfig
            .patch(
              process.env.REACT_APP_API_URL + order["@id"],
              { state },
              {
                headers: { "Content-Type": "application/merge-patch+json" },
              }
            )
            .then((response) => {
              if (response?.status === 200 && response?.data) {
                toast.success(t("settings.orders.updated"), {
                  theme: "colored",
                  hideProgressBar: true,
                });

                let newOrders = { ...orders };
                let orderIndex = orders["hydra:member"].findIndex(o => o.id === order.id);
                newOrders["hydra:member"][orderIndex] = response.data;
                setOrders(newOrders)
                //setOrder(response.data);
              }
            });
        } catch (e) {
          console.log(e);
        }
      }
    });
  };


  return (
    <>
      <div
        className={`grid ${
          isAdmin ? "grid-cols-4 lg:grid-cols-7" : "grid-cols-4 lg:grid-cols-5"
        } bg-bioport-blue-light text-white font-bold px-4 p-3 mt-5`}
      >
        <div className="text-center">{t("settings.orders.header.number")}</div>
        {isAdmin && <div className="hidden lg:block"></div>}
        <div className="hidden lg:block text-center">
          {t("settings.orders.header.date")}
        </div>
        {isAdmin && (
          <div className="hidden lg:block">
            {t("settings.orders.header.partner")}
          </div>
        )}
        <div className="text-center">{t("settings.orders.header.items")}</div>
        <div className="text-center">{t("settings.orders.header.state")}</div>
        <div className="text-center"></div>
      </div>
      {orders["hydra:member"].map((purchaseOrder, key) => (
        <OrderListRow
          purchaseOrderKey={key}
          purchaseOrder={purchaseOrder}
          loadOrders={loadOrders}
          key={key}
          updateState={updateState}
        />
      ))}
    </>
  );
}

export default OrderList;
